export const removeEmptyValues = (obj: Record<string, unknown>) => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] === '') {
      obj[key] = undefined;
    }
  }
  return obj;
};
